import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useGovernancaStatus } from '../hooks/useGovernancaStatus';
import { Loader2 } from 'lucide-react';

// Rotas que um profissional bloqueado por governança AINDA pode acessar.
// Mantido em sincronia com Sidebar (menu.filter isAllowed).
const ROTAS_LIVRES_BLOQUEIO = ['/dashboard/minhas-pendencias'];

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, session, loading } = useAuth();
  const location = useLocation();
  // Consulta status de governança (cache 60s, refresh 2min). Só relevante para profissional.
  const governanca = useGovernancaStatus();

  if (loading) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: '#FDFBF7' }}
      >
        <Loader2 
          className="h-8 w-8 animate-spin" 
          style={{ color: '#4A6B5D' }}
        />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Verificar perfis permitidos (se especificados)
  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.perfil)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Governança: profissional bloqueado só pode acessar /dashboard/minhas-pendencias.
  // Sem este guard, quem entra por URL direta / reload / botão voltar do
  // navegador conseguia usar toda a agenda e só via o erro ao clicar em
  // "Confirmar Remanejamento" (bug Márcia 2026-08).
  // Enquanto governanca.loading=true no primeiro render, aguardamos (default
  // esta_bloqueado=false não bloqueia por acidente).
  if (
    user?.perfil === 'profissional' &&
    governanca?.esta_bloqueado === true &&
    !ROTAS_LIVRES_BLOQUEIO.some((r) => location.pathname.startsWith(r))
  ) {
    return <Navigate to="/dashboard/minhas-pendencias" replace />;
  }

  return children;
};

export default ProtectedRoute;
